import { Component, OnDestroy, OnInit } from "@angular/core";
import { Page } from "../models/page.model";
import { OrderDirection } from "app/api/models";

@Component({
  template: "",
})
export abstract class Paging {
  public page: Page = new Page();
  public searchTerm: string;
  public orderDirection: OrderDirection;

  constructor() {
    this.page.pageIndex = 0;
    this.page.pageSize = 10;
  }

  updateSearchFilter(val) {
    this.searchTerm = val?.toLowerCase().trim();
    return this.regeneratePageContent();
  }

  setPage(pageInfo) {
    this.page.pageIndex = pageInfo.offset;
    this.load();
  }

  setPageSize(pageSize) {
    //if no change, don't call the API again
    if (this.page.pageSize == pageSize) return;

    this.page.pageSize = pageSize;
    this.regeneratePageContent();
  }

  setPageInfo(pageInfo) {
    console.log(pageInfo);
    // length: 12
    // pageIndex: 1
    // pageSize: 10
    // previousPageIndex: 0
    if(pageInfo.pageIndex == pageInfo.previousPageIndex)
      this.setPageSize(pageInfo.pageSize);
    else
      this.setPage({offset: pageInfo.pageIndex});
  }

  regeneratePageContent() {
    this.page.pageIndex = 0;
    this.load();
  }

  getOrderDirectionEnum(order: string) {
    switch (order) {
      case "asc":
        this.orderDirection = OrderDirection.Ascending;
        return;
      default:
        this.orderDirection = OrderDirection.Descending;
        return;
    }
  }

  load() {}

  getManualPagedItems(items: any[]) {
    var startI = this.page.pageIndex * this.page.pageSize;
    var endI = Math.min(startI + this.page.pageSize, items.length);
    return items.slice(startI, endI);
  }

  setPageInfoFromManualRes(items: any[]) {
    this.page.totalElements = items.length;
    this.page.totalPages = Math.ceil(items.length / (this.page.pageSize ?? 10));
  }
}
